import moment from 'moment'
import { APP_NAME } from '@/const/core'
import { BOOKING_TYPE } from '@/features/bookings/consts/booking'
import { BookingModel } from '@/features/bookings/types/models'
import i18n from '@/i18n'

export const setDocumentTitle = (title: string) => {
  document.title = `${title} | ${APP_NAME}`
}

export const downloadFile = (data: string, name: string) => {
  const blob = new Blob([data])

  const link = document.createElement('a')

  // Set the download attribute and href for the link
  link.href = window.URL.createObjectURL(blob)
  link.download = name // Specify the filename

  // Append the link to the document body
  document.body.appendChild(link)

  // Trigger the link to start the download
  link.click()

  // Remove the link from the document body
  document.body.removeChild(link)
}

export const getAsArrayIfNot = (item: any) => {
  if (!item) return []
  return Array.isArray(item) ? item : [item]
}

export const getHasNoValue = (item: any) => {
  if (!item || item === '') return true
  return false
}

export const convertListNamesToNames = (item: string[] | null) => {
  if (!item || !item.length) return ''
  const prefix = i18n.language === 'pt' ? 'o/a ' : ''
  const conjunction = i18n.language === 'pt' ? ' e ' : ' and '
  const formattedNames = item.map((name) => prefix + name)

  if (formattedNames.length === 1) {
    return formattedNames[0]
  }

  const allButLast = formattedNames.slice(0, -1).join(', ')
  const last = formattedNames[formattedNames.length - 1]

  return `${allButLast}${conjunction}${last}`
}

export const convertListNamesToNamesNoPrefix = (item: string[] | null) => {
  if (!item || !item.length) return ''
  const conjunction = i18n.language === 'pt' ? ' e ' : ' and '
  const formattedNames = item.map((name) => name)

  if (formattedNames.length === 1) {
    return formattedNames[0]
  }

  const allButLast = formattedNames.slice(0, -1).join(', ')
  const last = formattedNames[formattedNames.length - 1]

  return `${allButLast}${conjunction}${last}`
}

export const calcLastBookingDate = (booking: BookingModel) => {
  let lastCalcDate = moment(booking.date_end?.split('T')[0] + ' ' + booking?.time_end)
  if (
    (booking?.type === BOOKING_TYPE.ONETIME || booking?.type === BOOKING_TYPE.ANIMATION) &&
    booking?.timetable?.onetime_ranges
  ) {
    booking?.timetable?.onetime_ranges.forEach(function (range: any) {
      if (lastCalcDate.isBefore(moment(range.range_date_end))) {
        lastCalcDate = moment(range.range_date_end)
      }
    })
  }
  return lastCalcDate
}
